import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, Mail } from 'lucide-react';
import { useSiteStatus } from '../context/SiteStatusContext';
import { COMPANY } from './legal/companyConfig';

const ComingSoonPage = () => {
  const { headline, message } = useSiteStatus();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-[#F5FBFB] via-white to-[#F5FBFB]">
      <div className="max-w-lg w-full text-center bg-white rounded-2xl shadow-lg border border-[#659A9B]/20 p-8 md:p-10">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#659A9B] to-[#335E77] flex items-center justify-center">
            <Plane className="w-8 h-8 text-white" />
          </div>
        </div>
        <p className="text-sm font-semibold uppercase tracking-wider text-[#659A9B] mb-2">
          {COMPANY.brand}
        </p>
        <h1 className="text-2xl md:text-3xl font-bold text-[#1B375B] mb-4 font-[Outfit,system-ui,sans-serif]">
          {headline}
        </h1>
        <p className="text-gray-600 leading-relaxed mb-8">{message}</p>
        <nav className="flex flex-wrap justify-center gap-3" aria-label="Site links">
          <Link
            to="/contact-us"
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-[#659A9B] rounded-lg hover:bg-[#558889] transition-colors"
          >
            <Mail className="w-4 h-4" />
            Contact us
          </Link>
          <Link
            to="/terms"
            className="px-4 py-2 text-sm font-semibold text-[#1B375B] border border-[#659A9B]/40 rounded-lg hover:bg-[#659A9B]/10 transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="px-4 py-2 text-sm font-semibold text-[#1B375B] border border-[#659A9B]/40 rounded-lg hover:bg-[#659A9B]/10 transition-colors"
          >
            Privacy
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default ComingSoonPage;
